import * as types from './types';

export default {
    [types.SET_ICAL_URL](state, icalUrl) {
        state.icalUrl = icalUrl;
    },
};